import Box from '@mui/material/Box';
import { useColorScheme, useTheme } from '@mui/material';
import { Iconify } from 'src/components/iconify';

import { useSettingsContext } from 'src/components/settings';

import { CONFIG } from 'src/config-global';

import { Section } from './section';
import { Main, Content } from './main';
import { HeaderSection } from '../core/header-section';
import { LayoutSection } from '../core/layout-section';

// ----------------------------------------------------------------------

export function AuthSplitLayout({ sx, section, children, header }) {
  const layoutQuery = 'md';
  const theme = useTheme();
  const settings = useSettingsContext();
  const { mode, setMode } = useColorScheme();
  return (
    <LayoutSection
      headerSection={
        <HeaderSection
          disableElevation
          layoutQuery={layoutQuery}
          slotProps={{ container: { maxWidth: false } }}
          sx={{ position: { [layoutQuery]: 'fixed' }, ...header?.sx }}
          slots={{
            topArea: null,
            leftArea: null,
            rightArea: (
              <Box
                onClick={() => {
                  settings.onUpdateField('colorScheme', mode === 'light' ? 'dark' : 'light');
                  setMode(mode === 'light' ? 'dark' : 'light');
                }}
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: 'transparent', // Darker icon background for contrast
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: `1px solid ${theme.palette.text.disabled}`,
                  cursor: 'pointer',
                }}
              >
                <Iconify
                  icon={mode === 'light' ? 'solar:sun-bold-duotone' : 'material-symbols:dark-mode'}
                  width={20}
                  height={20}
                  sx={{ color: theme.palette.text.primary }}
                />
              </Box>
            ),
          }}
        />
      }
      footerSection={null}
      cssVars={{ '--layout-auth-content-width': '420px' }}
      sx={sx}
    >
      <Main layoutQuery={layoutQuery}>
        <Section
          layoutQuery={layoutQuery}
          imgUrl={section?.imgUrl}
          method={CONFIG.auth.method}
          subtitle={section?.subtitle}
          methods={[]}
        />
        <Content layoutQuery={layoutQuery}>{children}</Content>
      </Main>
    </LayoutSection>
  );
}
